export type Answer = 'Y' | 'N' | 'NONE';
export enum ApplicationState {
	RATE = 0,
	FORM = 1,
	THANKS = 2
}

export interface IState {
	sending: boolean;
	sent: boolean;
	answer: Answer;
	rateUrl: string;
	commentUrl: string;
	fcSiteId: string;
	strings: {
		main: {
			title: string;
			label: string;
		};
		yes: {
			button: string;
			sent: {
				title: string;
				text: string;
			}
		};
		no: {
			button: string;
			form: {
				title: string;
				text: string;
				label: string;
				submit: string;
			},
			sent: {
				title: string;
				text: string;
			}
		}
	},
	rateId?: string;
	applicationState: ApplicationState
}

const deafultState: IState = {
	sending: false,
	sent: false,
	answer: "NONE",
	rateUrl: '',
	fcSiteId: '',
	strings: {
		main: {
			label: '',
			title: ''
		},
		no: {
			button: '',
			form: {
				label: '',
				submit: '',
				text: '',
				title: ''
			},
			sent: {
				text: '',
				title: ''
			}
		},
		yes: {
			button: '',
			sent: {
				text: '',
				title: ''
			}
		}
	},
	commentUrl: '',
	applicationState: ApplicationState.RATE
}

export default deafultState;
